<div class="hints" cdkDrag>
  <div cdkDragHandle class="hints-header">
    <fa-icon [icon]="['fas', 'hand-back-fist']"></fa-icon>
    <sui-button
      size="sm"
      variant="ghost"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="onCloseClick()"
    ></sui-button>
  </div>
  <div class="feed-operators-holder">
    <app-feed-operator-list
      [feedOperators]="feedOperators$ | async"
      (onAddOperator)="addOperator($event)"
    ></app-feed-operator-list>
  </div>
</div>
